import React, { Component } from "react";
import "./Payments.css";
import axios from "axios";

import { Footerhome } from "../../components/footerhome/Footerhome";
import { Payform } from "../../components/payform/Payform";
import { Paypaypal } from "../../components/paypaypal/Paypaypal";

import Util from "../../util/util";

class Payments extends Component {
  constructor() {
    super();
    this.state = {
      usersData: localStorage.getItem("user_data")
        ? JSON.parse(localStorage.getItem("user_data"))
        : {},
    };
  }

  componentDidMount() {
    document.title = this.props.pageTitle;
  }

  doOpenPop = () => {
    Util.saveCustomEvent("open_pay_view");
    document.querySelector(".payform-info-popup-bank").classList.add("active");
  };

  doOpenPop2 = () => {
    Util.saveCustomEvent("open_pay_view_paypal");
    document.querySelector(".payform-info-popup-paypal").classList.add("active");
  };

  requestBill = () => {
    Util.saveCustomEvent("request_bill");

    axios.defaults.headers.common["Authorization"] = this.state.usersData.token;
    axios
      .post(window.ajaxLink + "user/requestbill")
      .then((res) => {
        Util.showPopupDialog(
          "Zatraži Predračun",
          "Hvala Vam na zahtjevu za predračun. U što kraćem roku dobićete predračun na adresu sa Vašeg profila",
          {
            title: "Zatvori",
            css: "middle_popup_yellow_button",
            callback: () => {},
          },
          { title: "", css: "", callback: () => {} },
          () => {},
          ""
        );
      })
      .catch((err) => {});
  };

  render() {
    return (
      <div className="payments_page">
        <div className="payments_top">
          Pogodnosti i Cijene za <div></div> Radnje
        </div>
        <div className="payments_section_top">
          OPK.ba je besplatan za korištenje i nije potrebno plaćati mjesečno za objavu oglasa ili kupovinu!
        </div>
      </div>
    );
  }
}

export default Payments;
